import React from 'react';
import { DollarSign, Ruler, Map, Truck, Calendar, FileCheck, Clock } from 'lucide-react';
export function Pricing() {
  const factors = [{
    icon: Ruler,
    text: 'Boat size, length, and beam'
  }, {
    icon: Map,
    text: 'Total transport distance'
  }, {
    icon: Truck,
    text: 'Open vs enclosed transport'
  }, {
    icon: Calendar,
    text: 'Season and time of year'
  }, {
    icon: FileCheck,
    text: 'Permits for oversized/wide-load'
  }];
  const timelines = [{
    distance: '0 – 1,000 mi',
    days: '1 – 3 days'
  }, {
    distance: '1,000 – 2,500 mi',
    days: '3 – 6 days'
  }, {
    distance: '2,500+ mi',
    days: '6 – 8 days'
  }];
  return <section className="py-20 bg-slate-50 border-y border-slate-200" data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-223">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-224">
            Transparent Boat Transport Pricing
          </h2>
          <p className="text-lg text-slate-600" data-id="element-225">
            We believe in honest, upfront pricing for boat shipping. No hidden
            fees, no bait-and-switch.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-226">
          {/* Pricing Main Card */}
          <div className="lg:col-span-5 bg-brand-navy text-white rounded-2xl p-8 shadow-xl flex flex-col justify-center text-center" data-id="element-227">
            <DollarSign className="w-16 h-16 text-brand-red mx-auto mb-4" data-id="element-228" />
            <h3 className="text-5xl font-black mb-2" data-id="element-229">$2 – $5</h3>
            <p className="text-xl font-bold text-slate-300 mb-6" data-id="element-230">
              per mile on average
            </p>
            <p className="text-slate-400 text-sm mb-8" data-id="element-231">
              Actual rate depends on vessel size and route. We provide a fixed
              quote with{' '}
              <strong className="text-white" data-id="element-232">
                no upfront payment required
              </strong>
              .
            </p>
            <button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-brand-red hover:bg-brand-red-hover text-white font-bold py-3 px-6 rounded-lg transition-colors w-full" data-id="element-233">
              Get Your Exact Price
            </button>
          </div>

          {/* Factors & Timeline */}
          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-234">
            {/* Factors */}
            <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm" data-id="element-235">
              <h4 className="text-xl font-bold text-brand-navy mb-4 border-b border-slate-100 pb-2" data-id="element-236">
                Cost Factors
              </h4>
              <ul className="space-y-3" data-id="element-237">
                {factors.map((factor, idx) => <li key={idx} className="flex items-center gap-3 text-slate-700" data-id="element-238">
                    <factor.icon className="w-5 h-5 text-brand-red shrink-0" data-id="element-239" />
                    <span data-id="element-240">{factor.text}</span>
                  </li>)}
              </ul>
            </div>

            {/* Timeline */}
            <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm" data-id="element-241">
              <h4 className="text-xl font-bold text-brand-navy mb-4 border-b border-slate-100 pb-2 flex items-center gap-2" data-id="element-242">
                <Clock className="w-5 h-5 text-brand-red" data-id="element-243" />
                Delivery Timeline
              </h4>
              <div className="space-y-4" data-id="element-244">
                {timelines.map((time, idx) => <div key={idx} className="flex justify-between items-center" data-id="element-245">
                    <span className="text-slate-600 font-medium" data-id="element-246">
                      {time.distance}
                    </span>
                    <span className="bg-slate-100 text-brand-navy font-bold px-3 py-1 rounded-md text-sm" data-id="element-247">
                      {time.days}
                    </span>
                  </div>)}
              </div>
              <p className="text-xs text-slate-400 mt-4 italic" data-id="element-248">
                * Timelines are estimates and depend on weather and road
                conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}